<template>
  <Component :is="getTag(type)" :style="attrs" class="text-container">
    <EditorParagraphBlockContent
      v-for="(item, idx) in content"
      :key="idx"
      :editable="editable"
      :marks="item.marks?.slice(1)"
      :mark="item.marks?.[0]"
      :text="item.text"
      :type="item.type"
      :attrs="item.attrs"
      :text-info="item.attrs?.text"
      @on-set-info="handleSetInfo"
    />
  </Component>
</template>

<script setup>
defineProps({
  editable: {
    type: Boolean,
    default: false,
  },
  attrs: {
    type: Object,
    default: () => ({}),
  },
  content: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'p',
  },
});

const handleSetInfo = (text) => {
  emit('on-set-info', text);
};

const getTag = (type) => {
  const types = {
    listItem: 'li',
  };

  return types[type] ?? type;
};
</script>
